export const OPEN_MODAL = 'containers/PhotoModal/OPEN_MODAL';
export const CLOSE_MODAL = 'containers/PhotoModal/CLOSE_MODAL';
export const MODAL_SUBMIT = 'containers/PhotoModal/MODAL_SUBMIT';
